import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { filterReducer } from "./filter";
import { filterOptionsReducer } from "./filterOptions";
import { fundsReducer } from "./funds";
import { fundReducer } from "./fund";
import { typeaheadReducer } from "./typeahead";
import { shareClassReducer } from "./shareClass";
import { loadingReducer } from "./loading";
import { sortingReducer } from "./sorting";
import { watchlistReducer } from "./watchlist";
import { disclaimerReducer } from "./disclaimers";
import { benchmarksReducer } from "./benchmarks";
import { sharePriceFundListReducer } from "./sharePriceFundList";
import { compareReducer } from "./compare";
import { infiniteScrollReducer } from "./infiniteScroll";
import { modalReducer } from "./modals";
import { IState } from "../models";

const rootReducer = combineReducers<IState>({
	router: routerReducer,
	funds: fundsReducer,
	typeahead: typeaheadReducer,
	filterOptions: filterOptionsReducer,
	filter: filterReducer,
	loading: loadingReducer,
	fund: fundReducer,
	shareClass: shareClassReducer,
	benchmarks: benchmarksReducer,
	sorting: sortingReducer,
	watchlist: watchlistReducer,
	compare: compareReducer,
	infiniteScroll: infiniteScrollReducer,
	disclaimers: disclaimerReducer,
	modals: modalReducer,
	sharePriceFundList: sharePriceFundListReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/client/reducers/index.ts